import React, { useEffect, useState } from "react";
import { Box, Typography, Button } from "@mui/material";
import { useNavigate, useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";

import BackLoading from "../../../composant/loading/backLoading";
import ImprimantSucces from "../../../composant/message/imprimanteSucces";
import Impressions from "../../../composant/impressions/impressions";
import { useImpressions } from "../../../service/useImpressions";
import EditImagePopup from "../../../composant/EditImage";
import { GetImageParCommand } from "../../../store/slice/CommandDahbordSlice";
import CategoryHashTags from "../../../composant/hashtags/categoryHashtagsSelected";
import CircularProgress from "@mui/material/CircularProgress";
import { ConfirmPrintPopup } from "../../../composant/Popup/confirmationImpression";

const downloadImage = (url, imageId) => {
  const link = document.createElement("a");
  link.href = url;
  link.download = `image_${imageId}`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export default function PageCommandTraiteParcode() {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // Retrieve images and imprimant data from the Redux store
  const images = useSelector((state) => state.commands?.PopupData?.images);
  const imprimant = useSelector(
    (state) => state.commands?.PopupData?.imprimant
  );
  const loadingpage = useSelector((state) => state.commands?.loading);

  useEffect(() => {
    dispatch(GetImageParCommand(id));
  }, [dispatch, id]);

  // Use our custom hook.
  // The hook returns all state & functions used by the Impressions component
  const {
    allImages,
    selectedImages,
    openCropper,
    demonsion,
    src,
    openPopup,
    handleSelectImage,
    handleSelectAll,
    editCountImage,
    sendToPrint,
    editImage, // Function to edit the image after cropping
    openImageCropper, // Opens the crop dialog for a specific image
    setOpenCropper,
    setOpenPopup,
    selectedCategories,
    setSelectedCategories,
    sendNewhastags,
    PopupCat,
    setPopupCat,
    NumberImpression,
  } = useImpressions(images, id, imprimant);
  const [popupConfirm, setPopupConfirm] = useState(false);
  if (loadingpage) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }
  return (
    <Box>
      <Typography variant="h4" textAlign="center" gutterBottom>
        Traitement des images
      </Typography>
      <Box sx={{ marginBottom: "200px" }}>
        {loadingpage ? (
          <h1>loading.....</h1>
        ) : (
          <Impressions
            allImages={allImages}
            selectedImages={selectedImages}
            handleSelectImage={handleSelectImage}
            downloadImage={downloadImage}
            openImageCropper={openImageCropper}
            editCountImage={editCountImage}
          />
        )}
      </Box>
      <Box
        position="fixed"
        bottom={0}
        width="100%"
        bgcolor="background.paper"
        p={2}
        boxShadow={3}
        display="flex"
        justifyContent="right"
        gap={2}
      >
        <Button variant="contained" onClick={handleSelectAll}>
          {selectedImages?.length === allImages?.length
            ? "Désélectionner tout"
            : "Sélectionner tout"}
        </Button>
        <Button variant="contained" onClick={() => setPopupCat(true)}>
          ajouter hashtags
        </Button>
        <Button
          variant="contained"
          color="error"
          onClick={() => {
            if (NumberImpression >= 1) {
              setPopupConfirm(true);
            } else {
              sendToPrint();
            }
          }}
        >
          Imprimer Images
        </Button>
        <Button
          variant="contained"
          //color="error"
          onClick={() => navigate(`/admin/CommandClientPage/${id}`)}
        >
          Terminer
        </Button>
      </Box>
      <EditImagePopup
        open={openCropper}
        onClose={() => setOpenCropper(false)}
        src={src}
        demonsion={demonsion}
        onSubmit={editImage}
      />
      <CategoryHashTags
        open={PopupCat}
        onClose={() => setPopupCat(false)}
        selectedCategories={selectedCategories}
        setSelectedCategories={setSelectedCategories}
        sendNewhastags={sendNewhastags}
      />
      <ConfirmPrintPopup
        open={popupConfirm}
        onClose={() => setPopupConfirm(false)}
        onConfirm={() => {
          sendToPrint();
          setPopupConfirm(false);
        }}
      />
      <BackLoading open={loadingpage} />
      {/**<BackLoadingSimple open={loadingpage} /> */}
      <ImprimantSucces open={openPopup} onClose={() => setOpenPopup(false)} />
    </Box>
  );
}
